import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { formatNumber } from "src/utils";
import { isUS } from "src/utils/account";
import "./Odometer.scss";
import { TradeIn, Unit } from "Types/TradeIn";
import MaskedInput from "react-text-mask";
import createNumberMask from "text-mask-addons/dist/createNumberMask";

interface OdometerProps {
    region: string;
    tradePending: Partial<TradeIn>;
    onChange: (data: Partial<TradeIn>) => void;
    onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
}

const Odometer = (props: OdometerProps) => {
    const { t } = useTranslation();

    const [amount, setAmount] = useState(formatNumber(props.tradePending.odometer?.amount));

    const handleOnChange = (event: any) => {
        setAmount(event.target.value);
    };

    const handleBlur = (event: any) => {
        const unit = isUS(props.region) ? Unit.Mi : Unit.KM;
        const value = parseInt(event.target.value.replace(",", ""), 10) || 0;

        props.onChange({
            odometer: { amount: value, unit },
        });
    };

    const handleOnFocus = (event: React.FocusEvent<HTMLInputElement>) => {
        props.onFocus && props.onFocus(event);
    };

    return (
        <div className="Odometer__container">
            {isUS(props.region)
                ? t("TradePending.Odometer.USQuestion", { model: props.tradePending.model })
                : t("TradePending.Odometer.noUSQuestion", { model: props.tradePending.model })}
            <MaskedInput
                className="Odometer__input"
                mask={createNumberMask({
                    prefix: "",
                    integerLimit: 6,
                })}
                guide={false}
                value={amount}
                onChange={handleOnChange}
                onFocus={handleOnFocus}
                onBlur={handleBlur}
                placeholder={t("TradePending.Odometer.placeholder")}
                type="string"
            />
        </div>
    );
};

export default Odometer;
